import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '@repo/ui/components/button';
import { useForm } from '@repo/ui/hooks/use-form';
import { useCurrentClub } from '@/hooks/use-current-club';
import { clubApi } from '@repo/api-client';
import { toast } from 'sonner';
import { File as FileInput } from '@repo/ui/components/form/file';
import { Image } from '@repo/ui/components/image';

function makeSquare(file: File): Promise<File> {
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    img.onload = () => {
      const size = Math.max(img.naturalWidth, img.naturalHeight);
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d')!;
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, size, size);
      const offsetX = (size - img.naturalWidth) / 2;
      const offsetY = (size - img.naturalHeight) / 2;
      ctx.drawImage(img, offsetX, offsetY);
      canvas.toBlob((blob) => {
        if (!blob) return reject(new Error('Failed to create blob'));
        resolve(new File([blob], file.name, { type: 'image/png' }));
      }, 'image/png');
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
}

export function ClubImages() {
  const club = useCurrentClub();
  const { ref, errors, values, handleChangeValue } = useForm({
    initialValues: {
      logo: undefined,
      logoPreview: undefined,
    },
    onSubmit: async () => {
      const body = new FormData();
      if (values.logo) {
        body.append('logo', values.logo);
      }
      await clubApi.updateLogo(club.id, body);
      toast.success('Logo actualizado correctamente');
    },
  });

  const logo = values.logoPreview || club.logo || '';

  return (
    <Card>
      <CardHeader>
        <CardTitle>Logo del Club</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-4 flex-1">
        <form ref={ref} className="flex flex-col gap-4 flex-1">
          <div className="flex items-center justify-center flex-1">
            <FileInput
              label="Logo"
              name="logoPreview"
              errors={errors}
              required
              accept="image/*"
              onChange={async (e) => {
                const file = e.currentTarget.files?.[0];
                if (!file) return;
                const squareFile = await makeSquare(file);
                const previewUrl = URL.createObjectURL(squareFile);
                handleChangeValue('logoPreview', previewUrl);
                handleChangeValue('logo', squareFile);
              }}
            >
              <Image src={logo} alt={club.name} className="w-24 h-auto" />
              <span className="text-sm font-medium text-primary underline">
                Click aqui para cambiar el logo
              </span>
            </FileInput>
          </div>
          <Button type="submit">Guardar</Button>
        </form>
      </CardContent>
    </Card>
  );
}
